import { Link } from "react-router-dom";

import { IUserInfo } from "components/widgets/types";
import { routes } from "@/common/utils/routes";
import { Image } from "@/components/UI/Image";
import FALLBACK from "@/common/images/icons/profileIcon.svg";

import "./UserTile.scss";
import { VerifiedIcon } from "components/UI/VerifiedIcon";
import { useSfw } from "@/common/hooks/useSfw";

interface IUserTileProps {
  user: IUserInfo;
}

export const UserTile = (props: IUserTileProps) => {
  const { sanitizeImage, isLoading } = useSfw();
  const thumbnail = props.user.image ? sanitizeImage(props.user.image) : null;

  if (isLoading) {
    return null;
  }

  return (
    <div className="userTile">
      <div className="main">
        <div className={`img-wrap ${!props.user.image ? "isEmpty" : ""}`}>
          <Link to={routes.user(props.user.id)} aria-label={`Link to ${props.user.id} profile`}>
            <Image className="thumbnail" src={thumbnail} fallback={FALLBACK} alt={`Poster for ${props.user.id}`} />
          </Link>
        </div>

        {props.user.verified && (
          <VerifiedIcon title={`Verified ${props.user.studio ? "channel" : "user"}`} isStudio={props.user.studio} />
        )}
      </div>

      <div className="label">
        <Link to={routes.user(props.user.id)}>{props.user.name}</Link>
      </div>
    </div>
  );
};
